module.exports = __webpack_public_path__ + "static/img/form-data.a3a093c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/form-data.png
// module id = LrNh
// module chunks = 46